import {hasFeatureValue, isSatisfied} from './values';

export function getArticleCode(decisions, features, productData) {
	return [...productData]
		.sort((a, b) => (a.displaySequenceCode ?? Infinity) - (b.displaySequenceCode ?? Infinity))
		.map(component => articleCodeForComponent(component, decisions))
		.filter(code => code !== '')
		.join(' - ');
}
export function getArticleCodeJoinedComponents(decisions, features, productData) {
	const joinedComponent = {
			componentId: 'joined',
			code: '',
			displaySequenceCode: 1,
			displaySequenceUi: 1,
			isVisible: true,
			features: productData.flatMap(component => component.features)
		};
	return articleCodeForComponent(joinedComponent, decisions);
}
export function getLightengine1Code(decisions, features, productData) {
	return [...productData]
		.filter(component => component.componentId === 'LE_1')
		.map(component => articleCodeForComponent(component, decisions))
		.filter(code => code !== '');
}
export function getLightengine2Code(decisions, features, productData) {
	return [...productData]
		.filter(component => component.componentId === 'LE_2')
		.map(component => articleCodeForComponent(component, decisions))
		.filter(code => code !== '');
}

function articleCodeForComponent(component, decisions) {
	const componentCode = (component.code !== null) ? component.code : '';

	let useComponentForCode = false;
	// find code for each feature of component
	const code = [...component.features]
		.filter(feature => feature.displaySequenceCode >= 0)
		.sort((a, b) => (a.displaySequenceCode ?? Infinity) - (b.displaySequenceCode ?? Infinity))
		.reduce((acc, currentFeature) => {
			let valueCode = '';
			let nullCodes = true;
			currentFeature.values.forEach(v => {
				if (v.code !== null) {
					const featureHasValue = hasFeatureValue(currentFeature.featureId, v.valueId, decisions);
					const featureIsSatisfied = isSatisfied(currentFeature.featureId, decisions);

					valueCode += featureHasValue ? v.code : '';
					nullCodes = false;
					// only use, when all features satisfied and decided or not yet satisfied (not available features are satisfied by default)
					useComponentForCode = useComponentForCode || (featureIsSatisfied && featureHasValue);
				}
			});
			if (!nullCodes) {
				valueCode = (valueCode === '') ? '_' : valueCode;
			}
			return acc + valueCode;
		}, '');

	return useComponentForCode ? componentCode + code : '';
}
